import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DisbursementOfficeApi from '../api/disbursement_office/disbursement_office.ts';

export const fetchDisbursementOfficeAsync = createAsyncThunk(
    'disbursementOffice/fetchDisbursementOffice',
    async () => {
        const response = await DisbursementOfficeApi();
        return response;
    }
);

const disbursementOfficeSlice = createSlice({
    name: 'disbursementOffice',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDisbursementOfficeAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchDisbursementOfficeAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
        });
        builder.addCase(fetchDisbursementOfficeAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default disbursementOfficeSlice.reducer;